import { TrackType } from '@goldcast/player-config/src/types/Track/Type';
import { Track } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Track/Track';

export const getTrackZIndex = (track: Track, originalIndex: number, tracks: Track[]): number => {
  if (track.type !== TrackType.ELEMENTS) {
    return originalIndex;
  }

  const elementTracks = tracks.filter(t => t.type === TrackType.ELEMENTS);
  const trackIndex = elementTracks.findIndex(t => t.id === track.id);
  const firstElementIndex = tracks.findIndex(t => t.type === TrackType.ELEMENTS);

  return firstElementIndex + elementTracks.length - 1 - trackIndex;
};
